import { render, staticRenderFns } from "./product-material.vue?vue&type=template&id=766cba94&scoped=true&"
import script from "./product-material.vue?vue&type=script&lang=js&"
export * from "./product-material.vue?vue&type=script&lang=js&"
import style0 from "./product-material.vue?vue&type=style&index=0&id=766cba94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766cba94",
  null
  
)

export default component.exports